import moment from "moment";
import { useRef } from "react";
import { Plus } from "react-feather";
import { Row, Col } from 'reactstrap';
import { Image } from "../../../AbstractElements";
import { XCircle } from "react-feather";
import { dynamicImage } from "../../../Service";
import { Button } from "reactstrap";

interface ADHDProps {
  fullName?: string
  onChange?: any
  adhdContent?: any
  handleUpload?: any
  logoUploaded?: any
  logoUrl?: any
  logoDimensions?: any
  signDimensions?: any
  signUploaded?: any
  signUrl?: any
  rewriteStatus?: any
  patient?: any
  generateSummary?: any
  handleFileChange?: any
  handleDeleteDoc?: any
  handleClickDoc?: any
  handleUploadClick?: any,
  documents: any
}

const ADHDTemplate = ({
  fullName,
  onChange,
  adhdContent,
  handleUpload,
  logoUploaded,
  logoUrl,
  logoDimensions,
  signDimensions,
  signUploaded,
  signUrl,
  rewriteStatus,
  patient,
  generateSummary,
  handleFileChange,
  handleDeleteDoc,
  handleClickDoc,
  documents
}: ADHDProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const logoInputRef = useRef<HTMLInputElement>(null);
  const signatureInputRef = useRef<HTMLInputElement>(null);

  const displayAge = (dob: string) => {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // Adjust age if the birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="d-flex flex-column gap-3 mt-4">
      <div className="d-flex justify-content-end w-100">
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ border: "1px dashed", width: '250px', height: '90px', cursor: 'pointer' }}
          onClick={() => logoInputRef.current?.click()}>
          <div>
            {logoUploaded
              ? <img
                src={logoUrl}
                alt="Uploaded logo"
                style={{ width: logoDimensions.width, height: logoDimensions.height }}
              />
              : <Plus />}
          </div>
          <input
            ref={logoInputRef}
            type="file"
            accept=".jpg,.jpeg,.png"
            style={{ display: "none" }}
            onChange={(e) => handleUpload(e, "logo")}
          />
        </div>
      </div>
      <div className="d-flex flex-column gap-3 w-100">
        <div className="fw-bold">{moment().format("Do MMMM YYYY")}</div>
        <div className="d-flex align-items-center gap-2">
          <div>{`Dear Dr.`}</div>
          <textarea value={adhdContent.docName} name="docName" onChange={onChange} rows={1} style={{ outline: 'none', resize: 'none', borderRadius: '4px' }} />
        </div>
        <div className="w-100 asdTemplate gap-3 w-100">
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Name:</span> {`${patient?.firstname || ""} ${patient?.lastname || ""}`}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">DOB:</span> {moment(patient?.birthday).format("YYYY-MM-DD")}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Age:</span>{` ${displayAge(patient?.birthday)} years old`}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Phone:</span>{patient?.phonenumber}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Address:</span>{patient?.address}</div>
          {
            patient?.type === "child" && <div className="d-flex align-items-center gap-2"><span className="fw-bold">School:</span>{patient?.school}</div>
          }
          {
            patient?.type === "child" && <div className="d-flex align-items-center gap-2"><span className="fw-bold">Parent:</span>{`${patient?.parent_firstname} ${patient?.parent_lastname}`}</div>
          }
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Date of Report:</span>{moment(Date.now()).format("YYYY-MM-DD")}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Date Seen:</span>
            <input className="border" type="date" style={{ padding: '0px 10px', borderRadius: '4px', outline: 'none' }} value={adhdContent.dateSeen} name="dateSeen" onChange={onChange} />
          </div>
        </div>
      </div>
      <div className="text-center w-100 fw-bold lh-lg mt-3">
        <div>Confidential Assessment Summary:</div>
        <div>Attention Deficit Hyperactivity Disorder (ADHD) - YOUNG DIVA 5:</div>
        <div>Diagnostic Interview for ADHD in young people (aged 5-17 years)</div>
      </div>
      <div className="w-100">
        <div className="w-100">
          <textarea
            style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
            className="w-100 py-1 px-2"
            name="basic"
            value={adhdContent.basic}
            onChange={onChange}
            rows={1}
          />
        </div>
        <div className="mt-1 d-flex">
          <span>We were able to successfully complete the Young DIVA-5 and it appears that</span>
          <select
            style={{
              padding: '0px 4px 0px 4px',
              border: 'none',
              borderBottom: '1px solid #8c2dbf',
              outline: 'none',
              appearance: 'none'
            }}
            value={adhdContent.gender}
            onChange={onChange}
            name="gender"
          >
            <option value="he">he</option>
            <option value="she">she</option>
          </select>
          <span>does</span>
          <select
            style={{
              padding: '0px 4px 0px 4px',
              border: 'none',
              borderBottom: '1px solid #8c2dbf',
              outline: 'none',
              appearance: 'none'
            }}
            value={adhdContent.diva}
            onChange={(e) => {
              onChange(e)
              if (e.target.value == "met") {
                const dsmCreterionAEvent = { target: { name: "dsmCreterionA", value: "Met" } }
                const dsmCreterionA2Event = { target: { name: "dsmCreterionA2", value: "Met" } }
                const dsmCreterionBCDEvent = { target: { name: "dsmCreterionBCD", value: "Met" } }
                onChange(dsmCreterionAEvent)
                onChange(dsmCreterionA2Event)
                onChange(dsmCreterionBCDEvent)
              }

            }
            }
            name="diva"
          >
            <option value="met">met</option>
            <option value="not met">not met</option>
          </select>
          <span>the diagnosis see below:</span>

        </div>
      </div>
      <div className="fw-bold lh-lg w-100">
        <select
          style={{
            padding: '0px 8px',
            border: '1px solid #8c2dbf',
            outline: 'none',
            borderRadius: '4px',
            appearance: 'none'
          }}
          value={adhdContent.typeSelect}
          onChange={onChange}
          name="typeSelect"
        >
          <option value="F314.01 (F90.2) ADHD, Combined Presentation">F314.01 (F90.2) ADHD, Combined Presentation</option>
          <option value="F314.00 (F90.0) ADHD, Predominantly Inattentive Presentation">F314.00 (F90.0) ADHD, Predominantly Inattentive Presentation</option>
          <option value="F314.01 (F90.1) ADHD, Predominantly Hyperactive/Impulsive Presentation">F314.01 (F90.1) ADHD, Predominantly Hyperactive/Impulsive Presentation</option>
        </select>
        <div className="d-flex align-items-center">
          <div>Severity - </div>
          <select
            name="severity"
            style={{ border: 'none', borderBottom: '1px solid black', outline: 'none', padding: '0px 5px', }}
            onChange={onChange}
            value={adhdContent.severity}
          >
            <option value="Mild">Mild</option>
            <option value="Moderate">Moderate</option>
            <option value="Severe">Severe</option>
          </select>
        </div>
        <div className="w-100">
          <table style={{ width: "70%", margin: '0 auto' }}>
            <tbody>
              <tr style={{ border: "1px solid" }}>
                <td className="text-center" style={{ border: "1px solid" }}>DSM Criterion A<div>(symptoms of attention deflcit)</div></td>
                <td className="text-center" style={{ border: "1px solid" }}>DSM Criterion A2 <div>(sysmptoms of hyperactivity-inpulsivity)</div></td>
                <td className="text-center" style={{ border: "1px solid" }}>DSM Criterion B/C/D <div>(impairment on account of symptoms)</div></td>
              </tr>
              <tr style={{ border: "1px solid" }}>
                <td className="px-2 pt-3" style={{ border: "1px solid" }}>
                  <select className="w-100" style={{ outline: 'none' }} name="dsmCreterionA" value={adhdContent.dsmCreterionA}
                    onChange={(e) => {
                      onChange(e)
                      if (e.target.value == "Not Met") {
                        console.log(e.target.value)
                        const dsmCreterionAEvent = { target: { name: "diva", value: "not met" } }
                        onChange(dsmCreterionAEvent)
                      }
                    }}
                  >
                    <option value="Not Met">Not Met</option>
                    <option value="Met">Met</option>
                  </select>
                </td>
                <td className="px-2 pt-3" style={{ border: "1px solid" }}>
                  <select className="w-100" style={{ outline: 'none' }} name="dsmCreterionA2" value={adhdContent.dsmCreterionA2}
                    onChange={(e) => {
                      onChange(e)
                      if (e.target.value == "Not Met") {
                        const dsmCreterionAEvent = { target: { name: "diva", value: "not met" } }
                        onChange(dsmCreterionAEvent)
                      }
                    }}>
                    <option value="Not Met">Not Met</option>
                    <option value="Met">Met</option>
                  </select>
                </td>
                <td className="px-2 pt-3" style={{ border: "1px solid" }}>
                  <select className="w-100" style={{ outline: 'none' }} name="dsmCreterionBCD" value={adhdContent.dsmCreterionBCD}
                    onChange={(e) => {
                      onChange(e)
                      if (e.target.value == "Not Met") {
                        const dsmCreterionAEvent = { target: { name: "diva", value: "not met" } }
                        onChange(dsmCreterionAEvent)
                      }
                    }}>
                    <option value="Not Met">Not Met</option>
                    <option value="Met">Met</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-5 w-100">
        <div className="fw-bold">Specific History Elicited Today:</div>
        <div className="mt-2">
          <textarea
            style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
            className="w-100 py-1 px-2"
            rows={5}
            name="specificHistory"
            value={adhdContent.specificHistory}
            onChange={onChange}
          />
        </div>
        <div className="mt-3">Social Skills and Emotional Regulation</div>
        <div className="mt-2">
          <textarea
            style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
            className="w-100 py-1 px-2"
            rows={6}
            name="socialSkills"
            value={adhdContent.socialSkills}
            onChange={onChange}
          />
        </div>
        <div className="mt-3">Sensory Processing Difficulties</div>
        <div className="mt-2">
          <textarea
            style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
            className="w-100 py-1 px-2"
            rows={4}
            name="sensoryProcessing"
            value={adhdContent.sensoryProcessing}
            onChange={onChange}
          />
        </div>
        <div className="mt-3">Strengths and Interests</div>
        <div className="mt-2">
          <textarea
            style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
            className="w-100 py-1 px-2"
            rows={4}
            name="strength"
            value={adhdContent.strength}
            onChange={onChange}
          />
        </div>
        <div className="mt-3">Contextual and Environmental Factors</div>
        <div className="mt-2">
          <textarea
            style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
            className="w-100 py-1 px-2"
            rows={4}
            name="contextual"
            value={adhdContent.contextual}
            onChange={onChange}
          />
        </div>
      </div>
      <div className="mt-4 w-100">
        <div className="fw-bold">Developmental History:</div>
        <div className="fw-bold mt-2">Pregnancy and Birth:</div>
        <div className="mt-2">
          <textarea
            style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
            className="w-100 py-1 px-2"
            rows={4}
            name="pregnancy"
            value={adhdContent.pregnancy}
            onChange={onChange}
          />
        </div>
      </div>
      <div className="mt-4 w-100">
        <div className="fw-bold">Gross Motor Skills:</div>
        <div className="mt-2">
          <textarea
            style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
            className="w-100 py-1 px-2"
            rows={3}
            name="grossMotor"
            value={adhdContent.grossMotor}
            onChange={onChange}
          />
        </div>
      </div>
      <div className="mt-4 w-100">
        <div className="fw-bold">Fine Motor Skills:</div>
        <div className="mt-2">
          <textarea
            style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
            className="w-100 py-1 px-2"
            rows={3}
            name="fineMotor"
            value={adhdContent.fineMotor}
            onChange={onChange}
          />
        </div>
      </div>
      <div className="mt-4 w-100">
        <div className="fw-bold">Speech and Language Development:</div>
        <div className="mt-2">
          <textarea
            style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
            className="w-100 py-1 px-2"
            rows={3}
            name="speechAndLanguage"
            value={adhdContent.speechAndLanguage}
            onChange={onChange}
          />
        </div>
      </div>
      <div className="mt-4 w-100">
        <div className="fw-bold">Bedwetting and Soiling:</div>
        <div className="mt-2">
          <textarea
            style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
            className="w-100 py-1 px-2"
            rows={3}
            name="betwetting"
            value={adhdContent.betwetting}
            onChange={onChange}
          />
        </div>
      </div>
      <div className="mt-4 w-100">
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div className="fw-bold">Report feedback:</div>
          <Button
            color={`secondary`}
            className="d-flex align-items-center px-2 py-1"
            style={{ gap: '4px', cursor: adhdContent.reportSummary || !documents?.length ? 'not-allowed' : 'pointer' }}
            onClick={generateSummary}
            disabled={adhdContent.reportSummary || !documents?.length ? true : false}
          >
            Summarise
          </Button>
        </div>
        <div style={{ marginTop: '10px' }}>(You can upload maximum 4 documents)</div>
        <div>
          <input
            type="file"
            ref={fileInputRef}
            multiple
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <div style={{ display: 'flex', marginTop: '0px' }}>
            {documents?.map((document: any, key: any) => (
              <div key={key} style={{ position: 'relative', width: '120px' }}>
                <div style={{ position: 'absolute', right: '8px', top: '0px', cursor: 'pointer' }} onClick={() => handleDeleteDoc(document)}>
                  <XCircle />
                </div>
                <Col className="p-2">
                  <Image className="img-fluid for-light" style={{ cursor: "pointer" }} src={dynamicImage("logo/PDF.png")} alt="doc" width={160} onClick={() => handleClickDoc(document.id)} />
                  <div className="ps-2" style={{ wordBreak: 'break-word' }}>{document.filename.split("__")[1]}</div>
                </Col>
              </div>
            ))}
            <div className='m-2 d-flex align-items-center justify-content-center' style={{ width: '90px', height: '103px', border: '1px solid #dee2e6', borderRadius: '4px', cursor: "pointer" }}
              onClick={handleUploadClick}
            >
              <Plus />
            </div>
          </div>
        </div>
        <div className="mt-2" dangerouslySetInnerHTML={{ __html: adhdContent.reportSummary && adhdContent.reportSummary.replaceAll(/\n/g, '<br />') }}></div>
      </div>
      <div className="mt-4 w-100">
        <div className="fw-bold">Summary/Recommendations</div>
        <div className="mt-2">
          <textarea
            style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
            className="w-100 py-1 px-2"
            rows={7}
            name="recommendations"
            value={adhdContent.recommendations}
            onChange={onChange}
          />
        </div>
      </div>

      {
        rewriteStatus === true && <div className="mt-4 w-100">
          <div className="fw-bold">Other Recommendations</div>
          <div className="mt-2">
            <textarea
              style={{ outline: 'none', resize: 'none', borderRadius: '4px' }}
              className="w-100 py-1 px-2"
              rows={7}
              name="additionalRecommendations"
              value={adhdContent.additionalRecommendations}
              onChange={onChange}
            />
          </div>
        </div>
      }


      <div className="lh-lg fw-bold mt-5">
        <div>Kind regards,</div>
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ border: "1px dashed", width: '250px', height: '90px', cursor: 'pointer' }}
          onClick={() => signatureInputRef.current?.click()}>
          <div>
            {signUploaded
              ? <img
                src={signUrl}
                alt="Uploaded logo"
                style={{ width: signDimensions.width, height: signDimensions.height }}
              />
              : <Plus />}
          </div>
          <input
            ref={signatureInputRef}
            type="file"
            accept=".jpg,.jpeg,.png"
            style={{ display: "none" }}
            onChange={(e) => handleUpload(e, "sign")}
          />
        </div>
        <div>{fullName}</div>
        <div>Registered Psychologist</div>
      </div>
    </div>
  )
}

export default ADHDTemplate;